import Roles from "@/shared/Roles";

// Roles allowed into the evaluation (APER) screens — mirrors the officer
// "Evaluations" nav item. Enforced by the officer router's role guard.
const evaluationRoles = [
    Roles.Supervisor,
    Roles.ExternalExaminer,
    Roles.Hod,
    Roles.Dean,
    Roles.DeanSpgs,
    Roles.SecretarySpgs,
];

export const sharedRoutes = [
    {
        path: '/evaluation/templates',
        component: () => import('@/pages/aper/TemplatesView.vue'),
        meta: { roles: evaluationRoles }
    },

    {
        path: '/evaluation/templates/:id',
        component: () => import('@/pages/aper/TemplateView.vue'),
        meta: { roles: evaluationRoles }
    },

    {
        path: '/evaluation/evaluations',
        component: () => import('@/pages/aper/EvaluationsListView.vue')
    },

    {
        path: '/evaluation/evaluations/:id',
        component: () => import('@/pages/aper/EvaluationView.vue'),
        props: true,
        meta: { roles: evaluationRoles }
    },

    {
        path: '/evaluation/evaluations/:id/summary',
        component: () => import('@/pages/aper/EvaluationSummaryView.vue'),
        props: true,
        meta: { roles: evaluationRoles }
    },
]
